import {
  DAILY_LEARNING_BOOKS,
  LAST_ATTENDANCE,
  LAST_STUDY,
  LEARNING_CONTENTS,
  LEARNING_KEYWORD,
  LEARNING_TOOLS,
  MAX_CONCENTRATION_TIME,
  NOTE_USAGE_TIME,
  PRIMARY_STUDY_DAYS,
  PRIMARY_STUDY_HOURS,
  TOTAL_STUDY_TIME,
} from './common';

export const CARD_CONFIGS = [
  { id: 'last-learning', title: LAST_STUDY },
  { id: 'last-date', title: LAST_ATTENDANCE },
  { id: 'keyword', title: LEARNING_KEYWORD },
  { id: 'tool', title: LEARNING_TOOLS },
  { id: 'content', title: LEARNING_CONTENTS },
  { id: 'total-time', title: TOTAL_STUDY_TIME },
  { id: 'time-range', title: PRIMARY_STUDY_HOURS },
  { id: 'day', title: PRIMARY_STUDY_DAYS },
  { id: 'book', title: DAILY_LEARNING_BOOKS },
  { id: 'focus', title: MAX_CONCENTRATION_TIME },
  { id: 'note', title: NOTE_USAGE_TIME },
] as const;
